/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TargetstemplatesTargetTemplate from './TargetstemplatesTargetTemplate';

/**
 * The TargetsTemplatesBody model module.
 * @module model/TargetsTemplatesBody
 * @version v0.3
 */
export default class TargetsTemplatesBody {
  /**
   * Constructs a new <code>TargetsTemplatesBody</code>.
   * @alias module:model/TargetsTemplatesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TargetsTemplatesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TargetsTemplatesBody} obj Optional instance to populate.
   * @return {module:model/TargetsTemplatesBody} The populated <code>TargetsTemplatesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TargetsTemplatesBody();
      if (data.hasOwnProperty('target_template'))
        obj.targetTemplate = TargetstemplatesTargetTemplate.constructFromObject(data['target_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TargetstemplatesTargetTemplate} targetTemplate
 */
TargetsTemplatesBody.prototype.targetTemplate = undefined;

